<template>
    <div class="xs-work-area ptb-100">
        <div class="container">
            <div class="section-header" data-aos="fade-up">
                <span class="section-tag">Unser Prozess</span>
                <h2>So arbeiten wir zusammen</h2>
                <p>Ein transparenter Prozess von der ersten Idee bis zum fertigen Projekt</p>
            </div>

            <div class="row justify-content-center align-items-center">
                <div class="col-lg-12 col-md-12">
                    <div class="sm-work-content">
                        <div class="sm-work-inner-card" data-aos="fade-right" data-aos-delay="0">
                            <div class="number">
                                <span>01</span>
                            </div>
                            <h4>Kostenloses Erstgespräch</h4>
                            <p>Wir lernen uns kennen und besprechen Ihre Anforderungen, Ziele und Vorstellungen. Unverbindlich und ohne Zeitdruck.</p>
                        </div>
                        <div class="sm-work-inner-card" data-aos="fade-left" data-aos-delay="100">
                            <div class="number">
                                <span>02</span>
                            </div>
                            <h4>Konzept & Angebot</h4>
                            <p>Sie erhalten ein detailliertes Angebot mit transparenter Kostenaufstellung. Keine versteckten Gebühren, keine Überraschungen.</p>
                        </div>
                        <div class="sm-work-inner-card" data-aos="fade-right" data-aos-delay="200">
                            <div class="number">
                                <span>03</span>
                            </div>
                            <h4>Umsetzung</h4>
                            <p>Wir entwickeln Ihr Projekt mit regelmäßigen Updates und Zwischenständen. Sie sind jederzeit im Bild über den Fortschritt.</p>
                        </div>
                        <div class="sm-work-inner-card" data-aos="fade-left" data-aos-delay="300">
                            <div class="number">
                                <span>04</span>
                            </div>
                            <h4>Launch & Betreuung</h4>
                            <p>Nach dem Go-Live lasse ich Sie nicht allein. Optionale Wartungspakete sorgen für eine langfristige Partnerschaft.</p>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="sm-work-image">
                        <!-- <img src="../../assets/img/seo-marketing/work.png" alt="Wie wir arbeiten"> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WieWirArbeiten'
}
</script>
